module.exports = __webpack_public_path__ + "assets/img/b6a7416e5de9dbbd55dc6e4d26b5d637.svg";